module.exports = __webpack_public_path__ + "img/logo_250.32b981c9.png";